import { createSlice } from "@reduxjs/toolkit";
import { AllCustomersModel, CustomerModel, SalesRegionsModel } from "../../app/types";


const initialState: AllCustomersModel = {
    customerList: []
}
const customerSlice = createSlice({
    name: 'customers',
    initialState,
    reducers: {
        setAllCustomers(state: AllCustomersModel, action:{payload: {customers: CustomerModel[], salesRegions: SalesRegionsModel[]} }) {
            

        }

        
        }
        
        
        });

export const {
    setAllCustomers
} = customerSlice.actions;
export default customerSlice.reducer

